'use strict'

import Axios from 'axios'
import { parseResponse, handleError } from '@/_helpers/utils.js'

export default {
  fetch (token) {
    return new Promise((resolve, reject) => {
      Axios.get(`/1.0/spec-public/bat-championship/business-plan/${token}`)
        .then(response => {
          resolve(parseResponse(response))
        })
        .catch(err => reject(handleError(err)))
    })
  },

  upload (token, {video_link, file}) {
    return new Promise((resolve, reject) => {
      const data = new FormData()
      data.append('file', file)
      data.append('video_link', video_link)

      Axios.post(`/1.0/spec-public/bat-championship/business-plan/${token}`, data)
        .then(response => {
          resolve(parseResponse(response))
        })
        .catch(err => reject(handleError(err)))
    })
  }
}
